import React, { useMemo } from 'react';
import Button from '@mui/material/Button';
import useApiControl from '../../../common/useApiControl';

function StartReserveButton(props) {
  const params = useMemo(() => ({
    eid: props.event.id,
    round: props.round.number,
  }), [props.event.id, props.round.number]);

  const { executeRequest } = useApiControl({
    action: '/start_round',
    params,
    method: 'POST',
  });

  const handleClick = () => {
    props.onRequestStart();

    executeRequest({
      ...params,
      scheduled_start_time: props.scheduledStartTime,
    })
      .then(() => {
        props.onStart();
      })
      .catch((error) => {
        console.error('Error scheduling round start:', error);
        const message = error?.response?.data?.message || '開始予約に失敗しました。';
        props.onRequestFailed(message);
      });
  };

  return (
    <Button
      variant="contained"
      color="secondary"
      onClick={handleClick}
      disabled={props.disabled}
      sx={{ ml: 1 }}
    >
      開始予約
    </Button>
  );
}

export default StartReserveButton;
